import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('UnsubscribedUserDrawer').create(({ theme }) => ({
  root: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
    pointerEvents: 'all',

    width: '100vw',
    height: '100%',

    gap: '8px',
    paddingTop: '44px',
  },
  heading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '24px',
    paddingBottom: '32px',

    span: {
      fontFamily: 'Inter',
      fontWeight: 350,
      fontSize: '13px',
      lineHeight: '18px',
      textAlign: 'center',
      padding: '0px 12px',
      color: theme.colors.text.secondary,
    },
  },

  logosWrapper: {
    display: 'flex',
    gap: '8px',
  },

  columns: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '10px',
    width: '90%',

    img: {
      paddingTop: '0px',
    },
  },

  basicValue: {
    fontFamily: 'Inter',
    fontSize: '15px',
    color: 'rgba(255, 255, 255, 0.65)',
    textWrap: 'nowrap',
  },

  plusValue: {
    fontFamily: 'Inter',
    fontSize: '15px',
    textWrap: 'nowrap',
    color: theme.colors.text.primary,
  },

  featureText: {
    fontFamily: 'Inter',
    fontWeight: 370,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: 'rgba(117, 119, 120, 1)',
    textTransform: 'uppercase',
  },

  basicText: {
    fontFamily: 'Inter',
    fontWeight: 550,
    fontSize: '13px',
    lineHeight: '18px',
    color: theme.colors.text.primary,
  },

  plusAndTextWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingRight: '4px',
  },

  plusText: {
    fontFamily: 'Inter',
    fontWeight: 450,
    fontSize: '13px',
    lineHeight: '18px',
    color: 'rgba(74, 107, 252, 1)',
  },

  featureList: {
    width: '100%',

    padding: '0 5vw',
    display: 'flex',

    flexDirection: 'column',
    overflow: 'scroll',
    gap: '12px',
    paddingBottom: '12px',
  },

  featureListItem: {
    display: 'flex',
    width: '100%',
    height: '46px',
    padding: '10px',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.background.secondary,

    ':first-child': {
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
    },

    ':last-child': {
      borderBottomLeftRadius: '12px',
      borderBottomRightRadius: '12px',
    },
  },

  // bad naming
  // what about now?
  columnTitlesWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '4px',
    position: 'relative',
    right: '8px',
    width: '33%',
  },

  iconsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  nameAndLogoWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  featureName: {
    fontFamily: 'Inter',
    fontWeight: 300,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.l,

    textWrap: 'nowrap',
    color: theme.colors.text.primary,

    '&[data-lang="ru"]': {
      fontSize: theme.sizes.texts.fontSize.s,
    }
  },

  availabilityWrapper: {
    width: '30%',

    padding: '0px 14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  controlsWrapper: {
    position: 'relative',
    width: '100%',
    padding: '0px 5%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',

    // boxShadow: '0px -22px 16px 0px rgba(29,30,34,.99)',
  },

  button: {
    height: '54px',
    fontSize: '16px',
    position: 'relative',
  },

  laterText: {
    fontFamily: 'Inter',
    // cursor: 'pointer',
    fontWeight: 360,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    textAlign: 'center',
    paddingBottom: '6px',
    color: 'rgba(250, 252, 255, 0.65)',
  },

  subscriptionOptions: {
    display: 'flex',
    paddingTop: '16px',
    flexDirection: 'column',
    gap: '8px'
  }
}))
